module.exports = __webpack_public_path__ + "static/integration-814efdeb58c72af348caf5f411142f16.png";